// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"95":"a5cc4f5b","214":"b4edb83f","419":"87fcbe24","439":"eccc3de5","458":"7af1c0f3","503":"4c7ca4f2","765":"ace57932","774":"8d0595f2","858":"b6a227ce"}[chunkId] + ".chunk.js";
};